var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',[(_vm.showEditButton)?_c('font-awesome-icon',{staticClass:"clickable float-right",attrs:{"id":"font-awesome-icon-edit","icon":"edit","size":"sm"},on:{"click":function($event){return _vm.$emit('edit-button-clicked')}}}):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.textToRender))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }